import { getRoot } from 'mobx-state-tree';
// import { IRootModel } from 'RootModel';
import schema, { generateType } from './Schema';
export const Library = generateType(schema.getModel('library'))
    .actions((self) => ({
    // This is an auto-generated example action.
    afterAttach() {
        const rootModel = getRoot(self); // as IRootModel;
        if (rootModel && !rootModel.currentLibrary) {
            console.log('Library after attach called, setting current library');
            rootModel.setCurrentLibrary(self);
            // hack way to wait for adminSession to be initialized
            // rootModel.setStatus('ready');
        }
    },
}))
    .views((self) => ({
    // This is aso we can get the id in a consistent way across Library and LibraryShare
    getLibraryID() {
        return self.id;
    },
}));
//# sourceMappingURL=LibraryModel.js.map